import { module } from 'modujs';
import LocomotiveScroll from 'locomotive-scroll';

export default class extends module {
    constructor(m) {
        super(m);
    }

    init() {
        this.scroll = new LocomotiveScroll({
            lenisOptions: {
                duration: 0.7,
                lerp: 0.5
            },
            scrollCallback({ scroll, limit, velocity, direction, progress }) {
                if (scroll > 20 && !document.documentElement.classList.contains('has-scrolled')) {
                    document.documentElement.classList.add('has-scrolled');
                } else if (scroll <= 20 && document.documentElement.classList.contains('has-scrolled')) {
                    document.documentElement.classList.remove('has-scrolled');
                }
            }
        });
    }

    toggleLazy(args) {
        let src = this.getData('lazy', args.obj.el)
        if(src.length) {
            if(args.obj.el.tagName == "IMG") {
                args.obj.el.src = src
            } else {
                args.obj.el.style.backgroundImage = `url(${src})`
            }
            this.setData('lazy', '', args.obj.el)
        }
    }

    destroy() {
        this.scroll.destroy();
    }
}
